module.exports = __webpack_public_path__ + "img/s4-5.ddea472b.jpg";